<template>
  <div class="recruit" :style="mainStyle">
    <div class="recruit-wrapper">
      <div class="r-head">
        <div class="r-position">{{ recruits[recruitId].position }}</div>
        <div class="r-subtitle">发布时间：{{ recruits[recruitId].publishDate }}</div>
      </div>
      <div class="company" style="margin-top: 10px;">
        <span>学历：</span>
        <span style="color: #60aff1;">{{ recruits[recruitId].education }}</span>
        <div class="separator-v"></div>
        <span>工作：</span>
        <span style="color: #60aff1;">{{ recruits[recruitId].experience }}</span>
        <div class="separator-v"></div>
        <span>薪资：</span>
        <span style="color: #60aff1;">{{ recruits[recruitId].salary }}</span>
      </div>

      <div class="r-body">
        <div class="r-title">岗位职责</div>
        <div class="r-content">
          <pre style="font-size: 16px; white-space: pre-wrap; word-wrap: break-word;">{{ recruits[recruitId].description }}</pre>
        </div>
        <div class="separator"></div>
        <div class="r-title">任职要求</div>
        <div class="r-content">
          <pre style="font-size: 16px; white-space: pre-wrap; word-wrap: break-word;">{{ recruits[recruitId].requirement }}</pre>
        </div>
        <div class="separator" v-show="recruits[recruitId].otherTitle !== undefined"></div>
        <div class="r-title" v-show="recruits[recruitId].otherTitle !== undefined">{{ recruits[recruitId].otherTitle }}</div>
        <div class="r-content" v-show="recruits[recruitId].other !== undefined">
          <pre style="font-size: 16px; white-space: pre-wrap; word-wrap: break-word;">{{ recruits[recruitId].other }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created() {
      let mainHeight = window.innerHeight - 108; // 总的高度 - footer的高度
      this.mainStyle['min-height'] = mainHeight + 'px';
    },
    data () {
      return {
        mainStyle: {
          'min-height': 'auto'
        },
        recruitId: this.$route.query.recruitid || '1',
        recruits: {
          1: {
            position: '产品经理',
            education: '本科',
            experience: '2年',
            salary: '15k~30k',
            publishDate: '2018/09/17',
            description: `1. 作为项目的产品负责人，对项目结果负责；
2. 进行移动端产品需求的定义及设计，能够完成简洁易懂的产品需求说明书；
3. 管理项目进度，协同各方跟进产品迭代至产品顺利上线；
4. 跟踪市场动向，分析用户反馈以及产品业务数据，以此为基础进行产品优化；`,
            requirement: `1. 对项目有强烈的责任心；善于沟通，有较强的团队意识；
2. 深入了解产品的研发流程，熟悉交互设计、市场分析、项目管理等相关知识；
3. 精通数据分析，善于从数据中获取有价值的信息，并转化为产品需求；
4. 有同理心，能够通过沟通完成资源的配置或解决问题；
5. 2年以上产品经验，有C端产品或移动广告项目优先；`
          },
          2: {
            position: '商务',
            education: '大专',
            experience: '1年',
            salary: '10k~20k',
            publishDate: '2018/09/17',
            description: `1、负责开拓有互联网广告投放需求的客户和广告主，包括电商、网服、移动互联网、游戏、金融、教育、本地商家等；
2、负责在线上线下开拓市场，销售公司旗下新媒体业务;
3、完成各项服务工作，包括具体方案策略的制定和优质资源的推荐；
4、对合作客户的投放效果负责，帮助客户实现利益最大化；
5、跟进公司分配的项目，做好客情维护和业务拓展；`,
            requirement: `1、大专及以上学历；1年以上工作经验；
2、对新媒体有一定的理解，对新媒体行业动态有浓厚的兴趣；
3、有相关行业销售经验，有客户资源优先，比如广告主、广告推广渠道、媒体资源等；
4、有较强的自我驱动力、学习能力与执行力。
5、销售过信息流产品的优先。`,
            otherTitle: '薪资待遇',
            other: `高底薪+绩效+高额提成
1、一经录用即签订正式劳动合同，五险一金，周末、法定节假日正常休息。
2、享受员工旅游、节日福利、员工生日会、带薪培训等；
3、每年享受带薪年假、法定节假日、员工旅游、员工体检、丰富的员工活动；
4、广阔的职业提升空间，公平的晋升机制，完整的职前培训和在职培训；
5、公司处在高速发展阶段，所有员工享受公平晋升平台，能力决定薪资，实力决定岗位；`
          },
          3: {
            position: '广告平台媒介',
            education: '本科',
            experience: '2年',
            salary: '8k~15k',
            publishDate: '2018/09/17',
            description: `1、对APP/小程序等采取稳定的流量来源策略，执行流量引入，并提升优化效果；
2、能熟练判断不同营销方案，不同业务需求的价值与可行性，给与对应的流量支撑；
3、负责对接推广渠道，维持良好合作关系，深度挖掘渠道资源；
4、协同运营构建平台自身流量池。`,
            requirement: `1、全日制本科及以上学历，熟悉流量运营，分析渠道流量质量，流量和步骤优化方向，将流量运营往最高效使用推进；
2、具备良好的逻辑思维和数据分析能力、执行力，计划统筹能力，及总结反思提升能力； 
3、熟悉手赚圈资源，对新媒体开发者的变现方式较为了解，如APP、小程序、双微自媒体等； 
4、具备一定的渠道商务谈判能力和资源整合能力；
5、2年以上程序化广告平台从业经验，自带渠道流量资源者优先。`,
          },
          4: {
            position: '品牌策划执行',
            education: '不限',
            experience: '2年',
            salary: '7k~13k',
            publishDate: '2018/09/17',
            description: `1、全面负责公司品牌及产品品牌规划、设计、推广及管理工作；
2、负责公司品牌宣传工作，包括建立线上、线下品牌宣传渠道，策划与执行线上、线下各类营销活动等；
3、开展市场调查，分析同行或竞争对手的品牌活动对公司的影响；
4、根据社会热点及流行趋势，及时调整公司营销策划方案，整合营销活动，包括广告创意、媒体投放、公关传播及事件营销等，并进行效果跟踪与优化；
5、建立和维护行业主流媒体资源，高效利用各类资源来执行品牌营销计划。
6、进行品牌定位、品牌VI、宣传语的设计与创意，提升品牌展现力；
7、发生危机公关事件时，进行有效的工作。`,
            requirement: `1、市场营销、广告、品牌传播、新闻等相关专业本科以上学历；
2、2年以上4A营销策划经验，品牌全案策划经验，有成功的品牌全程操盘经验功案例；
3、较强的创新思维，对市场信息的把握及反映速度快；较强的分析判断能力，创意及资源整合能力；文字表达能力强，擅长策略提案；
4、要有做过百度搜索优化或者百度SEM的经验
5、良好的逻辑思维能力，擅长品牌系统性策略建设，有发布会策划执行经验优先考虑；
6、擅长PPT制作，有一定的PS功底，有良好的团队合作精神。`,
          },
          5: {
            position: '后端广告算法工程师',
            education: '本科',
            experience: '2年',
            salary: '20k~30k',
            publishDate: '2018/09/17',
            description: `1.负责移动广告产品功能开发；
2.主导移动广告平台的相关算法和模型的开发与优化；
3.分析海量数据,为广告产品运营提供精准有效的数据分析优化流程,打造自动化业务支撑系统；`,
            requirement: `1.2年以上工作经验，计算机相关专业本科以上，；
2.精通Python/Golang/Java等一门以上语言；
3. 熟悉 Web 编程、网络编程（TCP/HTTP 协议），具有 Linux 下编程经验和操作经验；
4. 熟悉 MySQL/Elasticsearch/Hive 等数据存储方案，能根据业务需求快速设计高效的数据库，数据库性能优化，有SQL调优经验；
5. 熟悉 IO、多线程、集合等基础框架，熟悉分布式、缓存、消息、搜索等机制；
6. 熟悉常用的数据结构和算法，熟悉常见设计模式，对微服务，分布式系统设计模式有深刻的理解；
7. 有基于 Hadoop、Spark 的大数据处理开发经验，熟悉Linux操作系统的相关知识；
8.有分布式爬虫，亿级数据分析系统设计经验者优先；
9. 对客户端开发有一定了解；
10. 有维护个人技术博客1年以上者优先；开发过DSP平台者优先。`,
          },
          6: {
            position: 'JAVA开发工程师',
            education: '本科',
            experience: '2-3年',
            salary: '10k~20k',
            publishDate: '2018/09/17',
            description: `1、按照规范，进行Java代码编写和调试；主要从事服务端后台的开发，参与后端架构和产品的研发；
2、与产品人员共同确定产品的可行性，技术实施方案，并具体实施开发工作和测试工作；
3、能独立负责项目模块的技术开发和改进工作，性能优化，包括代码优化，数据库优化；
4、按照所分配的工作任务，独立、高效的完成任务，协助进行数据库设计、接口设计文档编写；
5、有开发IOS和Android APP接口和功能者，重点优先考虑；`,
            requirement: `1、计算机或者相关专业，本科及以上学历；需至少两年以上JAVA后台开发经验（必要条件）；
2、熟练掌握Eclipse/IDEA等开发工具；熟练掌握Git版本控制工具的使用；
3、熟悉HTML、CSS、JavaScript、Ajax、JQuery、JSP、EasyUI相关技术；
4、熟悉Springboot、SpringMVC、MyBatis开发框架（重点考察）；
5、熟悉Nginx、tomcat等服务器的安装配置及优化，Linux平台下的环境安装部署、性能优化；
6、熟悉tcp/ip、http等通信协议，具有多线程、socket网络编程等服务端开发经验；
7、熟悉常用设计模式，具有面向对象的分析和设计的能力；
8、熟悉Mysql数据库，SQL编写能力强，有SQL调优经验；
9、自我要求高，有激情、有创造力，对技术有不懈的追求者；`,
            otherTitle: '加分项',
            other: `1、有开源社区作品，有技术博客、个人域名、GitHub及相关专长领域者，优先考虑（重点考察）；
2、有信息流产品开发经验，或广告推荐算法有实战经验者，优先考虑（特别加分项）；
3、有防作弊系统开发验者，或平台服务搭建开发经验者，优先考虑（特别加分项）；
4、对hadoop，strom等计算平台有实战经验者，优先考虑（特别加分项）；
5、熟悉Spring Cloud、Docker、Dubbo、ZK、微服务架构等相关技术，优先考虑；
6、熟悉分布式系统的设计和应用，缓存、消息、负载均衡等机制和实现者，优先考虑；`
          },
          7: {
            position: 'PHP开发工程师',
            education: '本科',
            experience: '3年',
            salary: '9k~18k',
            publishDate: '2018/09/17',
            description: `1、参与公司产品、系统平台的需求分析与设计，撰写相关的技术文档；
2、负责公司产品的后台开发工作，如网站、app、小程序的后台开发；
3、负责接口开发；
4、负责产品代码的开发与维护，按计划完成功能模块的开发；
5、配合前端工程师完成开发工作;`,
            requirement: `1、计算机相关专业，本科及以上学历，3年及以上PHP开发经验，熟悉Thinkphp 的优先；
2、熟悉MySQL等数据库设计开发、SQL性能调优；
3、熟悉Linux/Unix，在其上有丰富的开发经验;
4、有一定的系统架构设计能力，能设计及编写良好的接口规范；
5、具备优秀的编程能力，熟悉HTTP/HTTPS等协议，熟练掌握常用的数据结构和算法；
6、深入了解缓存的作用，能合理使用缓存，有Memcached、Redis、MongoDB使用经验；
7、有很强的发现问题、分析问题和解决问题的能力；
8、善于沟通和逻辑表达，良好的团队合作精神和积极主动的沟通意识;
9、熟悉广告平台的业务的优先考虑;`,
          },
          8: {
            position: 'Android／IOS开发工程师',
            education: '本科',
            experience: '3年',
            salary: '18k~30k',
            publishDate: '2018/09/17',
            description: `1、负责公司移动产品Android & IOS的研发, 编写高质量的代码
2、负责核心框架功能的设计和开发
3、负责APP项目代码持续重构与优化代码、性能调优
4、指导初级开发工程师，完成研发任务
5、根据产品需求完成架构和模块设计、编码、测试工作；
6、负责重大或疑难问题的技术攻关
7、对新技术预研，并能主动思考与产品的结合方向，推动技术工具的演进，及研发团队文化建设 `,
            requirement: `1、计算机相关专业，本科以上，3年以上Android & IOS双端开发经验
2、良好的Java/ C/C++技术功底，熟悉面向对象软件设计思想，以及常见的设计模式；
3、熟悉Android／IOS下网络通信机制，对Socket通信、TCP/IP和HTTP有较深刻的理解和经验；
4、具有良好的工程能力，能够独立解决有一定复杂度的问题；
5、优秀的编码习惯，对于设计模式等常见的编码技巧有很好的认知
6、数据结构、算法等基础知识扎实，有良好的编码风格和架构设计能力
7、具有优秀的创新精神、钻研新技术的兴趣和能力，有较强的沟通能力、团队合作和高度的责任感；思维清晰、敏捷，能适应较大的工作压力。`,
          },
          9: {
            position: '系统测试工程师',
            education: '本科',
            experience: '2年',
            salary: '8k~15k',
            publishDate: '2018/09/17',
            description: `1、负责移动互联网产品系统功能测试；
2、负责APP前后端系统性能测试设计，执行，分析；
3、根据业务需要，开发接口自动化和性能测试自动化工具；
4、提升自动化测试水平和测试相关建设水平。 `,
            requirement: `1、计算机相关专业，本科(含)以上学历
2、有互联网产品功能测试经验；
3，至少熟悉一门语言，Python、Java优先
4、能够使用抓包工具进行问题定位与分析
5、熟悉常用的测试工具，实现稳定性、性能、自动化或安全测试
6、熟悉数据库基本操作
7、具备2年以上移动端测试经验，熟悉Android、iOS应用软件测试方法
8、有大数据相关项目测试经验者优先
9、具备良好的需求理解和分析能力，能够快速理解业务，识别业务风险并给出优化方案。
10、热爱软件测试工作，对技术有兴趣、有激情，善于学习，善于分析，对待工作细致、认真、富有耐心，拥有良好的沟通能力以及团队合作精神，较强的责任感和进取精神。`,
          },
          10: {
            position: '产品运营',
            education: '本科',
            experience: '2年',
            salary: '15k~30k',
            publishDate: '2018/11/20',
            description: `1、负责平台的用户增长、社交传播的产品运营工作，建立有效的产品运营策略和漏斗模型，提升用户的获取、新客转化、活跃等各节点的转化率。 
2.深入参与和分析用户使用场景，洞悉用户心理。不断迭代社交裂变传播方式和传播内容的展现形式及文案。
3.密切跟踪和分析各项数据，以增长为目标，针对数据变化，制定有效方案并跟进执行。
4.跟进互联网产品的变现目标，并能制定有效的策略，加上强有力的执行力促进达成。`,
            requirement: `1.两年以上互联网产品运营相关经验，熟悉了解互联网产品。
2.有较强文字功底，能够洞悉用户心理。
3.具有较强数据分析、逻辑分析能力，擅长通过数据分析来不断优化产品。 
4.工作认真细致，有创新思维，具备高度的执行力。 
5.有较强的抗压能力，良好的自我驱动力。`,
          },
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .recruit {
    padding-top: 40px;
    background-color: #f7fbfa;
    height: 100%;
    .recruit-wrapper {
      background-color: #ffffff;
      min-height: 200px;
      margin: 80px auto;
      padding: 0 20px;
      @media (min-width: 768px) {
        width: 100%;
      }
      @media (min-width: 800px) {
        width: 800px;
      }
      .r-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666666;
        border-bottom: solid 2px #ebeef5;
        .r-position {
          color: #333333;
          font-size: 30px;
          padding-top: 30px;
          padding-bottom: 16px;
        }
        .r-subtitle {
          font-size: 14px;
          color: #999999;
          margin-top: 30px;
        }
      }
      .company {
        color: #666666;
        display: flex;
        align-items: center;
        .separator-v {
          width: 0px;
          height: 14px;
          border-right: 1px solid #999999;
          margin: 0 20px;
        }
      }
      .r-body {
        padding: 40px 0;
      }
      .r-title {
        border-left: solid 10px #60aff1;
        padding-left: 10px;
        margin-bottom: 20px;
        font-size: 20px;
        color: #333333;
      }
      .r-content {
        color: #666666;
        line-height: 28px;
      }
      .separator {
        width: 100%;
        border-top: solid 1px #ebeef5;
        margin: 40px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/joinus/recruid-info.vue